<template>
  <div class="top-container">
    <div class="main-content">
      <!-- メインコンテンツ -->
      <div class="score-section">
        <div class="score-inner">
              <!-- スコア情報 -->
              <div class="score-info" @click="toggleScoreDisplay">
                <div class="score-content">
                  <div class="score-header">
                    <div class="score-text-container">
                      <div class="top-score-label">TOP SCORE</div>
                      <div class="score-value">{{ displayScore }}</div>
                    </div>
                  </div>
                  <div v-if="highestScoreYear !== ''" class="score-description">{{ $t('historiesTopScoreYearText', { topScoreYear: highestScoreYear }) }}</div>
                </div>
              </div>
          <!-- 画像カード -->
          <div class="image-card">
            <!-- 背景装飾 -->
            <div class="bg-decoration">
              <img 
                src="/img/campaign/reality_histories_20m/background_up_right.png"
                alt="背景装飾" 
                class="decoration-img"
              />
            </div>
            <!-- メイン画像カード -->
            <div class="main-card">
              <div class="card-image">
                <img 
                  v-if="userIconUrl"
                  :src="userIconUrl"
                  alt="ユーザーアバター" 
                  class="user-image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { HistoryAlbumUser } from '@/api/pb/HistoryAlbum/Common/HistoryAlbumUser'

const NO_SCORE_PLACEHOLDER = '--'

@Component({})
export default class Top extends Vue {
  @Prop({ type: Object, default: null })
  user!: HistoryAlbumUser | null

  @Prop({ type: Number, default: 0 })
  highestScore!: number

  @Prop({ type: String, default: '' })
  highestScoreYear!: string

  // スコア表示の状態（true: 数値表示, false: ハイフン表示）
  isScoreVisible: boolean = true

  // 実際のスコア値を取得
  get actualScore(): string {
    if (this.highestScore > 0) {
      return this.highestScore.toLocaleString()
    }
    return NO_SCORE_PLACEHOLDER
  }

  // 表示するスコア（切り替え可能）
  get displayScore(): string {
    return (this.isScoreVisible) ? this.actualScore : NO_SCORE_PLACEHOLDER
  }

  // ユーザーアイコンURLを取得
  get userIconUrl(): string {
    if (this.user && this.user.iconUrl) {
      return this.user.iconUrl
    }
    return ''
  }

  // スコア表示の切り替え
  toggleScoreDisplay(e: Event): void {
    e.preventDefault()
    this.isScoreVisible = !this.isScoreVisible
  }
}
</script>

<style scoped>
.top-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.main-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
  position: relative;
  width: 100%;
  height: 100%;
}


/* スコアセクション */
.score-section {
  height: 124px;
  position: relative;
  width: 100%;
  flex-shrink: 0;
}

.score-inner {
  display: flex;
  flex-direction: row-reverse;
  gap: 8px;
  height: 124px;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  position: relative;
  width: 100%;
}

/* スコア情報 */
.score-info {
  flex: 1;
  min-height: 1px;
  min-width: 1px;
  order: 2;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 48px;
}

.score-content {
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: flex-start;
  justify-content: center;
  padding: 0;
  position: relative;
  width: 100%;
}

.score-header {
  position: relative;
  flex-shrink: 0;
}

.score-text-container {
  display: flex;
  flex-direction: column;
  font-weight: 1000;
  font-style: italic;
  align-items: flex-start;
  justify-content: flex-start;
  line-height: 0;
  padding: 0 0 6px 0;
  position: relative;
  color: #7541ff;
  text-align: left;
}

.top-score-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: -6px;
  min-width: 100%;
  position: relative;
  flex-shrink: 0;
  font-size: 12px;
  line-height: normal;
}

.score-value {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: -6px;
  position: relative;
  flex-shrink: 0;
  font-size: 40px;
  white-space: nowrap;
  line-height: normal;
  /* スコアがプロフィールアイコンの上に表示されるのを保証 */
  z-index: 9999;
}

.score-description {
  font-weight: 600;
  font-style: normal;
  font-size: 12px;
  max-width: 200px;
  color: #171636;
  text-align: left;
  line-height: normal;
}

/* 画像カード */
.image-card {
  order: 1;
  position: relative;
  right: -8px;
  width: 124px;
  height: 124px;
  flex-shrink: 0;
}

.bg-decoration {
  position: absolute;
  overflow: hidden;
  right: -8px;
  width: 200px;
  height: 200px;
  top: -36px;
}

.decoration-img {
  width: 200px;
  height: 200px;
  object-fit: cover;
  display: block;
}

.main-card {
  position: absolute;
  background: #ffffff;
  left: 0;
  box-shadow: 0px 0px 4px 0px rgba(100, 100, 100, 0.2);
  width: 124px;
  height: 124px;
  top: 0;
}

.card-image {
  background-size: 150% 324.8%;
  position: absolute;
  background-position: 65.87% 31.17%;
  background-repeat: no-repeat;
  left: 8px;
  width: 108px;
  height: 108px;
  top: 8px;
  background-color: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.user-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
